module.exports = new __parcel__URL__("low-priority.2e35e1bc.svg").toString();